import {FC} from 'react';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import ServiceRequestsTable from './ServiceRequestsTable';

const ServiceRequests: FC = () => {
  return (
    <Box sx={{width: '100%'}}>
      <Paper sx={{width: '96%', marginX: 'auto', mt: 4, mb: 4}}>
        <ServiceRequestsTable />
      </Paper>
    </Box>
  );
};

export default ServiceRequests;
